import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Override browser-native validation messages with Spanish
document.addEventListener('invalid', (e) => {
  const el = e.target;
  const v = el.validity;
  if (v.valueMissing) {
    el.setCustomValidity('Por favor completa este campo');
  } else if (v.tooShort) {
    el.setCustomValidity(`Mínimo ${el.minLength} caracteres`);
  } else if (v.rangeUnderflow) {
    el.setCustomValidity(`El valor mínimo es ${el.min}`);
  } else if (v.rangeOverflow) {
    el.setCustomValidity(`El valor máximo es ${el.max}`);
  } else if (v.typeMismatch || v.badInput) {
    el.setCustomValidity('Por favor ingresa un valor válido');
  } else {
    el.setCustomValidity('Valor inválido');
  }
  const clear = () => {
    el.setCustomValidity('');
    el.removeEventListener('input', clear);
    el.removeEventListener('change', clear);
  };
  el.addEventListener('input', clear);
  el.addEventListener('change', clear);
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
